var map = {
	"./amplify-amazon-button_5.entry.js": [
		"77e1",
		"chunk-60df2cf2"
	],
	"./amplify-auth-container.entry.js": [
		"398f",
		"chunk-2d0bad0a"
	],
	"./amplify-auth-fields_9.entry.js": [
		"2689",
		"chunk-92a29f4c"
	],
	"./amplify-authenticator.entry.js": [
		"b836",
		"chunk-51470c54",
		"chunk-2d2105ef"
	],
	"./amplify-button_3.entry.js": [
		"efa9",
		"chunk-2d23154f"
	],
	"./amplify-chatbot.entry.js": [
		"9b2c",
		"chunk-16d4b9b3"
	],
	"./amplify-checkbox.entry.js": [
		"db86",
		"chunk-2d228cf2"
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		"e862",
		"chunk-51470c54",
		"chunk-2d226365"
	],
	"./amplify-container.entry.js": [
		"a72f",
		"chunk-2d208de0"
	],
	"./amplify-federated-buttons_2.entry.js": [
		"644c",
		"chunk-522a38c6"
	],
	"./amplify-federated-sign-in.entry.js": [
		"a81f",
		"chunk-35d3c3ea"
	],
	"./amplify-form-field_4.entry.js": [
		"f988",
		"chunk-181d2b20"
	],
	"./amplify-greetings.entry.js": [
		"57dd",
		"chunk-58be091e"
	],
	"./amplify-icon-button.entry.js": [
		"182d",
		"chunk-2d0abfcf"
	],
	"./amplify-icon.entry.js": [
		"b8f5",
		"chunk-e5e547a4"
	],
	"./amplify-link.entry.js": [
		"f482",
		"chunk-2d22c8fe"
	],
	"./amplify-nav_2.entry.js": [
		"23a0",
		"chunk-d688bb3a"
	],
	"./amplify-photo-picker.entry.js": [
		"c4f1",
		"chunk-394e349e"
	],
	"./amplify-picker.entry.js": [
		"d040",
		"chunk-394e93ea"
	],
	"./amplify-radio-button_3.entry.js": [
		"97a4",
		"chunk-51470c54",
		"chunk-2d0e6487"
	],
	"./amplify-s3-album.entry.js": [
		"4e6f",
		"chunk-32be053c",
		"chunk-39398983"
	],
	"./amplify-s3-image-picker.entry.js": [
		"b90a",
		"chunk-32be053c",
		"chunk-394dccaa"
	],
	"./amplify-s3-image.entry.js": [
		"76ad",
		"chunk-32be053c",
		"chunk-2d0d7838"
	],
	"./amplify-s3-text-picker.entry.js": [
		"5af2",
		"chunk-32be053c",
		"chunk-3939f47a"
	],
	"./amplify-s3-text.entry.js": [
		"dce0",
		"chunk-32be053c",
		"chunk-394f594c"
	],
	"./amplify-select-mfa-type.entry.js": [
		"fef4",
		"chunk-6b4304ff"
	],
	"./amplify-sign-in-button.entry.js": [
		"7358",
		"chunk-f993edd8"
	],
	"./amplify-tooltip.entry.js": [
		"1faa",
		"chunk-2d0b722b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "521b";
module.exports = webpackAsyncContext;